window.Products.Clothing.ShirtBellacanvas3001 = function() {
};
window.Products.Clothing.ShirtBellacanvas3001.inherits(window.Products.Clothing.Shirt);
window.Products.Clothing.ShirtBellacanvas3001.dpi = 150;
window.Products.Clothing.ShirtBellacanvas3001.has_3d = true;
window.Products.Clothing.ShirtBellacanvas3001.id = 83;
window.Products.Clothing.ShirtBellacanvas3001.slug = 'shirt-bellacanvas-3001';
window.Products.Clothing.ShirtBellacanvas3001.syncColors = true;
window.Products.Clothing.ShirtBellacanvas3001.texturesLoaded = 0;
window.Products.Clothing.ShirtBellacanvas3001.texturesLoading = false;
window.Products.Clothing.ShirtBellacanvas3001.use_glb = true;

window.Products.Clothing.ShirtBellacanvas3001.prototype.handleColorOption = function(modelViewer, color){
	var me = modelViewer.product;

	var object = modelViewer.object;
	if(!object) return;

	if(!color) {
		if(modelViewer.inlab){
			$('#button_options_color').find('img').attr('src', $(this).find('img').attr('src'));
			$('#container_options_color, #button_options_color').removeClass('active');
			color = $(this).attr('for');
		} else {
			color = $('#productInfo-productOption-color').find('option:selected').attr('data-slug');
		}
	}

	var three_color = me.getColor(color);

	object.children[1].material.color = three_color;
	if(typeof me.insideObject !== "undefined") {
		object.children[me.insideObject].material.color = three_color;
	}

	me.updateThreeTexture(modelViewer);
	var three_intensity = 1.5;

	if(color == "athletic_heather" || color == "heather-grey"){
		three_intensity = 2.5;
	}

	object.children[me.outsideObject].material.aoMapIntensity = three_intensity;

	if(typeof me.insideObject !== "undefined") {
		object.children[me.insideObject].material.aoMapIntensity = three_intensity;
	}
};

window.Products.Clothing.ShirtBellacanvas3001.prototype.getColor = function(_name){
	colors = {
		"black": 0x171616,
		"navy": 0x3f3e68,
		"white": 0xffffff,
		"storm": 0x877e83,
		"true_royal": 0x2d4e95,
		"royal-blue": 0x315ad7,
		"canvas_red": 0xa0242f,
		"red": 0x901819,
		"dark_grey": 0x3d3b3a,
		"athletic_heather": 0xc7c8c9,
		"heather-grey": 0xc7c8c9,
	};

	return new THREE.Color(colors[_name]);
};